import { makeStyles, tokens } from "@fluentui/react-components";

export const useClauseHeaderStyles = makeStyles({
  header: {
    display: "flex",
    alignItems: "center",
    gap: tokens.spacingHorizontalS,
    marginBottom: tokens.spacingVerticalM,
  },
});
